import * as React from 'react';
import {
BulletIcon,
BulletPointSection,
BulletPointText,
BulletSectionCard,
BulletSectionWrapper,
BulletWrapper,
SupportingContent,
SupportingContentHeading,
SupportingContentHeadingWrapper,
SupportingContentImage,
SupportingContentImageWrapper,
BulletPointTitle,
BulletPointContent
} from './BulletSectionStyles'
import { language } from './BulletSectionLanguage';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { cssVarColors } from '../../../../Constants/cssVarColors';
import { faCoffee } from '@fortawesome/free-solid-svg-icons';
import { BulletSectionHeadingLayout } from './BulletSectionHeadingLayout';
import {SectionTitle} from "../../HomePageStyles";

export type Props = {
	mobile: boolean;
	schema: any;
};

export const BulletSectionLayout = (props: Props) => {
	const render = () => {
		const image = "http://google.com";
		const returnValue = (
			<BulletSectionWrapper>
				<SectionTitle>
					Beyond the Brief
				</SectionTitle>
				<BulletSectionCard>
					<SupportingContentHeadingWrapper>
						<SupportingContentHeading>{props.schema.title}</SupportingContentHeading>
					</SupportingContentHeadingWrapper>
					<SupportingContent>
						<SupportingContentImageWrapper image={props.schema.image} />
						<BulletPointSection>{generateBulletPoints(props.schema.bullets)}</BulletPointSection>
					</SupportingContent>
				</BulletSectionCard>
			</BulletSectionWrapper>
		);
		return returnValue;
	};
	const outerReturnValue = render();
	return outerReturnValue;
};

const generateBulletPoints = (schema: Array<any>) => {
	const returnValue = schema.map((bulletPoint: any, index: number) => {
		const innerReturnValue = (
			<BulletWrapper key={'BulletPoint' + index}>
				<BulletIcon>{bulletPoint.icon}</BulletIcon>
				<BulletPointContent>
					<BulletPointTitle>{bulletPoint.title}</BulletPointTitle>
					<BulletPointText>&nbsp;- {bulletPoint.text}</BulletPointText>
				</BulletPointContent>
			</BulletWrapper>
		);
		return innerReturnValue;
	});
	return returnValue;
};
